import { render } from "./AllExternalClinics.vue?vue&type=template&id=67507f9e&scoped=true"
import script from "./AllExternalClinics.vue?vue&type=script&lang=js"
export * from "./AllExternalClinics.vue?vue&type=script&lang=js"

import "./AllExternalClinics.vue?vue&type=style&index=0&id=67507f9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67507f9e"]])

export default __exports__